import { z } from "zod";
import { contractSchema } from "@/types/schemas/contract";

export type Contract = z.infer<typeof contractSchema>;

export enum Commodity {
  Electricity = "01",
  Gas = "02",
}

export const CommodityEnumSchema = z.nativeEnum(Commodity);
export type CommodityEnum = z.infer<typeof CommodityEnumSchema>;

export enum Process {
  SUPPLIER_CHANGE = "S1",
  DPI = "S2",
  CHANGED_WITH_HAND_OVER = "S3",
  UNAUTHORIZED_SP = "S4",
  S5 = "S5",
  RECONTRACTING = "ZSP",
  NEW_POINT = "R1",
  UNAUTHORIZED = "R2",
  UNAUTHORIZED_PREVENTION = "R3",
  R5 = "R5",
  MOBILITY_SERVICES = "MS",
  AFFIDAVIT = "PZC",
  VRB = "VRB",
  TCR = "TCR",
  ZDP = "ZDP",
  PS = "PS",
}

export const acquisitionProcesses = [
  Process.SUPPLIER_CHANGE,
  Process.DPI,
  Process.CHANGED_WITH_HAND_OVER,
  Process.UNAUTHORIZED_SP,
  Process.NEW_POINT,
  Process.UNAUTHORIZED,
  Process.UNAUTHORIZED_PREVENTION,
];

export const ProcessEnumSchema = z.nativeEnum(Process);
export type ProcessEnum = z.infer<typeof ProcessEnumSchema>;

export enum Segment {
  B2C = "B2C",
  B2B = "B2B",
  ALL = "All",
}

export const SegmentEnumSchema = z.nativeEnum(Segment);

export enum ProcessSpecification {
  R1 = "R1",
  V1 = "V1",
  S1 = "S1",
  S2 = "S2",
  COC = "with_change_of_customer",
  NO_COC = "without_change_of_customer",
  RESERVED = "reserved",
  NEW_CONNECTION = "new_connection",
  ADHOC = "adhoc",
  ONLINE = "online",
  ZDP = "change_of_distribution_product",
  TCR = "request_for_contract_termination",
  ZSP = "ZSP",
  EMPTY = "", // BE returning empty string
}

export const ProcessSpecificationEnumSchema = z.nativeEnum(ProcessSpecification);

export type ContractState = {
  contract: Contract;
  sessionKey: string | undefined;
  uuid: string;
};

export enum Phase {
  REQUEST = "request",
  CONTRACT = "contract",
  CONTRACT_FROM_REQUEST = "contract_from_request",
  LEAD = "lead",
}

export const PhaseEnumSchema = z.nativeEnum(Phase);
export type PhaseEnum = z.infer<typeof PhaseEnumSchema>;

export enum DistributionArea {
  Egd = "egd",
  Pre = "pre",
  Ppd = "ppd",
  Cez = "cez",
  Gasnet = "gasnet",
}

export const DistributionAreaEnumSchema = z.nativeEnum(DistributionArea);

export enum StornoType {
  CUSTOMER = "CUSTOMER",
  ADMIN = "ADMIN",
}

export const StornoTypeSchema = z.nativeEnum(StornoType);
export type StornoTypeEnum = z.infer<typeof StornoTypeSchema>;

export enum StornoTypeUrl {
  StornoCustomer = "STORNO_CUSTOMER",
  StornoAdmin = "STORNO_ADMIN",
}

export const StornoTypeUrlSchema = z.nativeEnum(StornoTypeUrl);
export type StornoTypeUrlEnum = z.infer<typeof StornoTypeUrlSchema>;
